// removed by extract-text-webpack-plugin
module.exports = {"grid-figure":"_2G2jJo7OBbqtixcL7ydY5o","control-buttons":"_2ReNCo3KJG0s9DQMBPBZx8"};


//////////////////
// WEBPACK FOOTER
// ./src/styles/components/CardAdd.styl
// module id = 559
// module chunks = 0